import type { ITagAssociation } from '@xbl/types'
import { tagAssociationList } from '@/services'
import { useCallback, useState } from 'react'

export default function useSpuAssociate() {
  const [data, setData] = useState<ITagAssociation[]>([])

  const getTagAssociationList = useCallback(async (params: { buyers_id?: number, news_id?: number }) => {
    const res = await tagAssociationList(params)
    setData(res.data)
  }, [])

  return {
    tagAssociationList: data,
    getTagAssociationList
  }
}
